// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__Tj8xA","formControl":"addForm_formControl__uR4vf","list":"addForm_list__XPLBg","btnWrpper":"addForm_btnWrpper__h0Rhu"};